import { render, staticRenderFns } from "./FieldUsecases.vue?vue&type=template&id=0ca8df18&scoped=true"
import script from "./FieldUsecases.vue?vue&type=script&lang=js"
export * from "./FieldUsecases.vue?vue&type=script&lang=js"
import style0 from "./FieldUsecases.vue?vue&type=style&index=0&id=0ca8df18&prod&lang=css"
import style1 from "./FieldUsecases.vue?vue&type=style&index=1&id=0ca8df18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca8df18",
  null
  
)

export default component.exports